
const digest = '3a13a8642c72df67fd787fb4165f6864532d3daa86bbd719069ef1c5a5057c01';
const classes = {"container":"_container_1dbct_1","day":"_day_1dbct_6","month":"_month_1dbct_11","year":"_year_1dbct_16"};
const css = `._container_1dbct_1 {
  display: flex;
  width: 100%;
}

._day_1dbct_6 {
  flex: 1;
  margin-right: 15px;
}

._month_1dbct_11 {
  flex: 1;
  margin-right: 15px;
}

._year_1dbct_16 {
  flex: 1.3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  